export const OFFICE_GROUP_EXPORT_ID = 'office-group';

export const OFFICE_GROUP_TITLE = 'Grupos de Oficinas de Venta';

export const LOCALIZED_PROPERTIES = {
  name: 'Nombre',
  company: 'Compañía',
  status: 'Estado',
};
